import axios from "axios"
import { isEmpty } from "@/utils/common-helpers"
import { sanitizeTimestamps } from "@/utils/timestamp-utils"
import { sanitizeError, logErrorSafely } from "@/utils/error-handler"

const backendURL = process.env.NEXT_PUBLIC_API_BASE_URL

export const postRequest = async (URL: any, formData: any, token?: any) => {
  let error: any = null

  const response: any = await axios
    .post(backendURL + URL, formData, token && { headers: token })
    .catch((e) => {
      error = e.response
      logErrorSafely(e, `POST ${URL}`)
    })

  if (isEmpty(error)) {
    // Sanitize timestamps in response data
    if (response?.data) {
      response.data = sanitizeTimestamps(response.data);
    }
    return response
  }
  
  // Return sanitized error
  return {
    ...error,
    data: error?.data ? {
      ...error.data,
      message: sanitizeError(error.data).message
    } : sanitizeError(error)
  }
}

export const getRequest = async (URL: any) => {
  let error: any = null
  const response: any = await axios.get(backendURL + URL).catch((e) => {
    error = e.response
    logErrorSafely(e, `GET ${URL}`)
  })
  if (isEmpty(error)) {
    // Sanitize timestamps in response data
    const sanitizedData = sanitizeTimestamps(response?.data);
    return sanitizedData
  }
  
  // Return sanitized error
  return {
    ...error,
    data: error?.data ? {
      ...error.data,
      message: sanitizeError(error.data).message
    } : sanitizeError(error)
  }
}
